// frontend/src/livequiz/Confetti.js
import React, { useMemo } from 'react';

const COLORS = ['#4f46e5', '#f59e0b', '#16a34a', '#dc2626', '#0ea5e9'];

const Confetti = ({ count = 40 }) => {
    const pieces = useMemo(() => {
        return Array.from({ length: count }, (_, i) => ({
            id: i,
            left: Math.random() * 100,
            delay: Math.random() * 0.5,
            duration: 1.5 + Math.random() * 1,
            color: COLORS[i % COLORS.length],
            rotate: Math.random() * 360
        }));
    }, [count]);

    return (
        <div className="livequiz-confetti-container">
            {pieces.map(p => (
                <div
                    key={p.id}
                    className="livequiz-confetti-piece"
                    style={{
                        left: `${p.left}%`,
                        backgroundColor: p.color,
                        animationDelay: `${p.delay}s`,
                        animationDuration: `${p.duration}s`,
                        transform: `rotate(${p.rotate}deg)`
                    }}
                />
            ))}
        </div>
    );
};

export default Confetti;